<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M84.4799 19.76C83.6999 17.83 82.0099 16.55 80.1099 16.19C79.6499 16.07 79.1599 16 78.6599 16H66.1199C62.1199 16 58.8799 19.24 58.8799 23.24C58.8799 27.24 62.1199 30.48 66.1199 30.48H73.1899L79.5899 46.32C80.8099 49.33 84.2299 50.78 87.2399 49.57L95.2199 46.34L84.4699 19.76H84.4799Z"
      fill="#CB80DE"
    />
    <path
      d="M107.13 39.78L83.3501 34.4C78.0901 33.21 73.0901 37.21 73.0901 42.6V45.06L18.4601 49.09C14.0001 49.42 10.5601 53.13 10.5601 57.6C10.5601 62.31 14.3801 66.13 19.0901 66.13H31.5701L42.8901 80.94C45.2301 84 48.5801 85.75 52.0901 85.75H76.6801C80.1901 85.75 83.5401 84 85.8801 80.94L97.2001 66.13H109.8C114.44 66.13 118.21 62.37 118.21 57.72V53.64C118.21 47 113.61 41.24 107.13 39.78Z"
    />
    <path
      d="M97.9399 111.74C110.538 111.74 120.75 101.528 120.75 88.9301C120.75 76.3325 110.538 66.1201 97.9399 66.1201C85.3423 66.1201 75.1299 76.3325 75.1299 88.9301C75.1299 101.528 85.3423 111.74 97.9399 111.74Z"
      fill="#CB80DE"
    />
    <path
      d="M30.81 111.74C43.4076 111.74 53.62 101.528 53.62 88.9301C53.62 76.3325 43.4076 66.1201 30.81 66.1201C18.2124 66.1201 8 76.3325 8 88.9301C8 101.528 18.2124 111.74 30.81 111.74Z"
      fill="#CB80DE"
    />
  </svg>
</template>

<script>
  export default {
    name: 'AtvLoan'
  }
</script>
